import React, {Component} from 'react';
import TransitionLink from 'components/transition-link/transition-link';
import Button from 'components/button/button';
import Text from 'components/text/text';

export default class ResetPasswordSuccess extends Component {
  constructor(props) {
    super(props);
    this.message = `Your password has been successfully reset.`;
  }

  render() {
    return (
      <div className="container container_centered">
        <Text
          className="lgPlus"
          color="Lightest"
          type="lg"
          weight="light"
        >
          {this.message}
        </Text>
        <div className="set">
          <div className="set-bd set-bd_giant">
            <Button theme="dark" onClick={this.props.close}>Ok</Button>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/client/modal/reset-password-success.jsx